/**
 * Square metres as km², which is how areas are shown across the dashboard.
 *
 * The name says both units because the two are easy to confuse: most areas
 * reaching the UI are already km², and only a few arrive raw from a geodesic
 * measurement. A caller that already holds km² wants a different function.
 *
 * A touching area shares a boundary and no area, so it reads 0 rather than
 * being hidden; a sliver too small for two decimals reads as less than the
 * smallest figure we would show, never as 0 — rounding it to `0.00 km²` would
 * say there is no overlap when there is one.
 */
export const formatSquareMetresToKm2 = (squareMetres: number | null | undefined): string => {
    if (squareMetres == null) return '—';

    const km2 = squareMetres / 1_000_000;
    if (km2 === 0) return '0 km²';
    if (km2 < 0.01) return '< 0.01 km²';
    return `${km2.toFixed(2)} km²`;
};
